import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';
import { API_URL } from './utils/constants';

export const getPrivateThread = async ({
  userId,
  projectId,
  parentThreadId,
}) => {
  const apiPath = `chat/${projectId}/${userId}/get-private-thread`;

  const request = {
    url: `${API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'POST',
    region: Config.AWS_REGION,
    service: 'execute-api',
    body: JSON.stringify({ parentThreadId }),
    data: { parentThreadId },
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const signedRequest = await createSignedRequest(request);

  const response = await axios(signedRequest);

  return response.data;
};
